import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";

const PORTAL = { buyer: "/buyer", vendor: "/vendor" };

// Buyers and vendors read the Guide outside the staff layout, with a way back to their portal.
function PortalFrame({ back, children }) {
  return (
    <div className="min-h-screen bg-zinc-100">
      <header className="bg-black text-white px-4 sm:px-8 py-3 flex items-center">
        <Link to={back} data-testid="help-back-to-portal"
          className="border border-white px-3 py-1.5 text-xs uppercase tracking-widest hover:bg-white hover:text-black inline-flex items-center gap-2 transition-colors duration-100">
          <ArrowLeft size={12} weight="bold" /> Back to my portal
        </Link>
      </header>
      <main className="p-4 sm:p-8">{children}</main>
    </div>
  );
}

function Frame({ children }) {
  const { user } = useAuth();
  const back = PORTAL[user?.role];
  return back ? <PortalFrame back={back}>{children}</PortalFrame> : <Layout>{children}</Layout>;
}

export default function HelpShell({ children }) {
  return (
    <ProtectedRoute>
      <Frame>{children}</Frame>
    </ProtectedRoute>
  );
}
